

























































import Vue from 'vue';
import layout from '@/libs/layout/school/leads';
import { Component, Prop } from 'vue-property-decorator';
import { TLeadsPage, TLeadsList } from '@/types/views/school';
import { TLayout } from '@/types/utils';
@Component({
  components: {
    Remark: () => import('./remark-dialog.vue')
  }
})
export default class List extends Vue {
  @Prop({
    type: Object,
    default() {
      return {
        totalPage: 1,
        currentPage: 1,
        pageSize: 20,
        list: []
      };
    }
  })
  page!: TLeadsPage;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleReset!: Function;
  private layout: TLayout = layout;
  private activeId = 0

  private handlePage(page: number) {
    this.handleOptions({ currentPage: page });
    this.getData();
  }
  private handleSize(size: number) {
    this.handleOptions({ pageSize: size });
    this.getData();
  }

  private handleDetail(row: TLeadsList) {
    let { id, phone } = row;
    id &&
      phone &&
      this.$router.push({
        name: 'leads-detail',
        params: {
          id
        },
        query: {
          phone
        }
      });
  }
  private showLeadsRemark(id: number) {
    this.activeId = id;
    (this.$refs.remarkDialog as any).dialogVisible = true;
  }
}
